module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0